export const CLIENT_NAV = [
  { to: "/", label: "Home", icon: "Home", end: true },
  { to: "/plan", label: "My Plan", icon: "Target" },
  { to: "/weekly-focus", label: "Weekly Focus", icon: "CalendarCheck" },
  { to: "/actions", label: "Actions", icon: "ListChecks" },
  { to: "/scorecard", label: "Scorecard", icon: "Gauge" },
  { to: "/coaching", label: "Coaching", icon: "Users" },
  { to: "/business-health", label: "Business Health", icon: "Activity" },
  { to: "/issues", label: "Issues & Decisions", icon: "TriangleAlert" },
  { to: "/resources", label: "Resources", icon: "BookOpen" },
  { to: "/ask-amden", label: "Ask Amden", icon: "Sparkles" },
  { to: "/reports", label: "Reports", icon: "BarChart3" },
  { to: "/settings", label: "Settings", icon: "Settings" },
];

// Team Workspace entries, inserted after Home when the company has Team Workspace switched on.
export const WORKSPACE_NAV = [
  { to: "/workspace", label: "My Workspace", icon: "Briefcase", self: true },
  { to: "/team", label: "Team", icon: "Network", team: true },
];

// Bottom navigation for employee (My Workspace only) accounts — each opens a My Workspace tab.
export const WORKSPACE_BOTTOM_NAV = [
  { tab: "work", label: "My work", icon: "ListChecks" },
  { tab: "kpis", label: "KPIs", icon: "Gauge" },
  { tab: "leave", label: "Leave", icon: "Plane", need: "leave" },
  { tab: "time", label: "Time", icon: "Clock", need: "clocking" },
  { tab: "resources", label: "Resources", icon: "BookOpen" },
  { tab: "profile", label: "Profile", icon: "IdCard" },
];

export const AMDEN_NAV = [
  { to: "/portfolio", label: "Portfolio", icon: "LayoutGrid", end: true },
  { to: "/clients", label: "Clients", icon: "Building2" },
  { to: "/users", label: "Users", icon: "UsersRound" },
  { to: "/amden-team", label: "Amden Team", icon: "ShieldCheck", superOnly: true },
  { to: "/resources", label: "Resources", icon: "BookOpen" },
  { to: "/audit", label: "Audit Log", icon: "ScrollText" },
];

export const CLIENT_BOTTOM_NAV = [
  { to: "/", label: "Home", icon: "Home", end: true },
  { to: "/actions", label: "Actions", icon: "ListChecks" },
  { to: "/weekly-focus", label: "Check-in", icon: "CalendarCheck" },
  { to: "/ask-amden", label: "Ask Amden", icon: "Sparkles" },
  { to: "/coaching", label: "Coaching", icon: "Users" },
];

export const AMDEN_BOTTOM_NAV = [
  { to: "/portfolio", label: "Portfolio", icon: "LayoutGrid", end: true },
  { to: "/clients", label: "Clients", icon: "Building2" },
  { to: "/users", label: "Users", icon: "UsersRound" },
  { to: "/resources", label: "Resources", icon: "BookOpen" },
];

// Toggleable client workspace modules (Home & Settings are always-on). key -> {label, route}
export const MODULE_ROUTES = {
  "/plan": "plan",
  "/weekly-focus": "weekly_focus",
  "/actions": "actions",
  "/scorecard": "scorecard",
  "/coaching": "coaching",
  "/business-health": "business_health",
  "/issues": "issues",
  "/resources": "resources",
  "/ask-amden": "ask_amden",
  "/reports": "reports",
};

export const moduleEnabled = (org, key) => {
  if (!org || !key) return true;
  return (org.module_access || {})[key] !== false;
};


export const AI_PROMPTS = [
  "What should I focus on this week?",
  "Why are we falling behind?",
  "Prepare me for my next coaching session.",
  "Summarise my outstanding actions.",
  "Help me solve a business issue.",
  "Draft a plan from our company dossier.",
  "What are the biggest risks in our business right now?",
];
